var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 33.53V13.92C59.387 13.432 62 10.519 62 7C62 3.141 58.86 0 55 0C51.14 0 48 3.141 48 7H0V47H30.051C30.571 55.356 37.516 62 46 62C54.822 62 62 54.822 62 46C62 40.961 59.653 36.465 56 33.53ZM55 2C57.757 2 60 4.243 60 7C60 9.757 57.757 12 55 12C52.243 12 50 9.757 50 7C50 4.243 52.243 2 55 2ZM2 9H48.295C48.534 9.798 48.914 10.533 49.402 11.185L43.286 17.301C42.894 17.113 42.462 17 42 17C41.538 17 41.106 17.113 40.715 17.301L38.7 15.286C38.887 14.894 39 14.462 39 14C39 12.346 37.654 11 36 11C34.346 11 33 12.346 33 14C33 14.462 33.113 14.894 33.301 15.285L28.286 20.3C27.894 20.113 27.462 20 27 20C25.346 20 24 21.346 24 23C24 24.654 25.346 26 27 26C28.654 26 30 24.654 30 23C30 22.538 29.887 22.106 29.699 21.715L34.714 16.7C35.106 16.887 35.538 17 36 17C36.462 17 36.894 16.887 37.285 16.699L39.3 18.714C39.113 19.106 39 19.538 39 20C39 21.654 40.346 23 42 23C43.654 23 45 21.654 45 20C45 19.538 44.887 19.106 44.699 18.715L50.816 12.599C51.731 13.285 52.817 13.75 54 13.921V32.166C51.643 30.797 48.916 30 46 30C41.22 30 36.934 32.118 34 35.453V31H28V43H30.292C30.168 43.653 30.093 44.322 30.051 45H2V9ZM42 19C42.551 19 43 19.448 43 20C43 20.552 42.551 21 42 21C41.449 21 41 20.552 41 20C41 19.448 41.449 19 42 19ZM35 14C35 13.448 35.449 13 36 13C36.551 13 37 13.448 37 14C37 14.552 36.551 15 36 15C35.449 15 35 14.552 35 14ZM28 23C28 23.552 27.551 24 27 24C26.449 24 26 23.552 26 23C26 22.448 26.449 22 27 22C27.551 22 28 22.448 28 23ZM46 54C41.589 54 38 50.411 38 46C38 41.589 41.589 38 46 38C50.411 38 54 41.589 54 46C54 50.411 50.411 54 46 54ZM32 38.271C31.521 39.135 31.125 40.048 30.811 41H30V33H32V38.271ZM45 32.051V36.051C39.954 36.555 36 40.824 36 46C36 47.463 36.324 48.85 36.891 50.104L33.422 52.107C32.52 50.259 32 48.191 32 46C32 38.618 37.747 32.567 45 32.051ZM46 60C41.186 60 36.932 57.557 34.412 53.845L37.895 51.834C39.713 54.352 42.664 56 46 56C49.336 56 52.287 54.352 54.105 51.834L57.588 53.845C55.068 57.557 50.814 60 46 60ZM58.578 52.107L55.109 50.104C55.676 48.85 56 47.463 56 46C56 40.824 52.046 36.554 47 36.051V32.051C54.253 32.567 60 38.618 60 46C60 48.191 59.48 50.259 58.578 52.107Z",
    fill: "#59595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40C42.691 40 40 42.691 40 46C40 49.309 42.691 52 46 52C49.309 52 52 49.309 52 46C52 42.691 49.309 40 46 40ZM46 50C43.794 50 42 48.206 42 46C42 43.794 43.794 42 46 42C48.206 42 50 43.794 50 46C50 48.206 48.206 50 46 50Z",
    fill: "#59595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11H6V13H4V11Z",
    fill: "#59595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H22V13H8V11Z",
    fill: "#59595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H6V17H4V15Z",
    fill: "#59595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H22V17H8V15Z",
    fill: "#59595B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H6V21H4V19Z",
    fill: "#59595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H22V21H8V19Z",
    fill: "#59595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H6V25H4V23Z",
    fill: "#59595B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23H22V25H8V23Z",
    fill: "#59595B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4 43H10V33H4V43ZM6 35H8V41H6V35Z",
    fill: "#59595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 43H18V35H12V43ZM14 37H16V41H14V37Z",
    fill: "#59595B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 43H26V27H20V43ZM22 29H24V41H22V29Z",
    fill: "#59595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPresentation);
export default __webpack_public_path__ + "static/media/data_presentation.1439aaa16f2e400477b06ec43da97ad6.svg";
export { ForwardRef as ReactComponent };